// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Invite Team Member Modal component styles */

.invite-team-member-container {
  width: 100%;
  padding: 0;
  overflow-y: auto;
  max-height: 90vh;
}

.invite-form-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.invite-form-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
  line-height: 1.3;
}

.invite-form-description {
  font-size: 0.95rem;
  color: #555;
  margin: 0;
  padding: 0;
  line-height: 1.5;
  word-wrap: break-word;
}

.invite-form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.invite-form-field label {
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
}

.invite-select {
  border: 1px solid #ccc !important;
  border-radius: 4px;
  padding: 8px 12px !important;
  font-size: 0.9rem;
  font-family: inherit;
  background-color: white;
  cursor: pointer;
  min-height: 40px;
}

.invite-select:focus {
  outline: none;
  border-color: #5148fa !important;
  box-shadow: 0 0 0 2px rgba(81, 72, 250, 0.1);
}

.invite-error-wrapper {
  margin: 0.5rem 0;
}

.invite-button-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
  width: 100%;
}

.invite-button-primary,
.invite-button-secondary {
  width: 100% !important;
  min-height: 40px;
  font-size: 0.95rem;
  padding: 0.75rem 1rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invite-button-primary {
  margin: 0 !important;
}

.invite-button-secondary {
  margin: 0 !important;
}

/* Responsive adjustments for larger screens */
@media (min-width: 640px) {
  .invite-button-group {
    flex-direction: row;
    gap: 1rem;
  }

  .invite-button-primary,
  .invite-button-secondary {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/inviteTeamMember/InviteTeamMember.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,OAAO;EACT;AACF","sourcesContent":["/* Invite Team Member Modal component styles */\n\n.invite-team-member-container {\n  width: 100%;\n  padding: 0;\n  overflow-y: auto;\n  max-height: 90vh;\n}\n\n.invite-form-content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.invite-form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n  line-height: 1.3;\n}\n\n.invite-form-description {\n  font-size: 0.95rem;\n  color: #555;\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n\n.invite-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.invite-form-field label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n.invite-select {\n  border: 1px solid #ccc !important;\n  border-radius: 4px;\n  padding: 8px 12px !important;\n  font-size: 0.9rem;\n  font-family: inherit;\n  background-color: white;\n  cursor: pointer;\n  min-height: 40px;\n}\n\n.invite-select:focus {\n  outline: none;\n  border-color: #5148fa !important;\n  box-shadow: 0 0 0 2px rgba(81, 72, 250, 0.1);\n}\n\n.invite-error-wrapper {\n  margin: 0.5rem 0;\n}\n\n.invite-button-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.invite-button-primary,\n.invite-button-secondary {\n  width: 100% !important;\n  min-height: 40px;\n  font-size: 0.95rem;\n  padding: 0.75rem 1rem !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.invite-button-primary {\n  margin: 0 !important;\n}\n\n.invite-button-secondary {\n  margin: 0 !important;\n}\n\n/* Responsive adjustments for larger screens */\n@media (min-width: 640px) {\n  .invite-button-group {\n    flex-direction: row;\n    gap: 1rem;\n  }\n\n  .invite-button-primary,\n  .invite-button-secondary {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
